import React from 'react';
import { SectionEyebrow, SectionTitle, SectionLead, GhostLink, Reveal } from './UI';
import { brand, pool } from '../../data/mock';
import { IMAGE_SIZES, responsiveImageProps } from '../../lib/images';

const Introduction = ({ onBook }) => {
  return (
    <section id="introduction" className="bg-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5">
            <Reveal>
              <SectionEyebrow>Welcome</SectionEyebrow>
              <SectionTitle className="mt-6">A quiet address on the shore of the strait.</SectionTitle>
            </Reveal>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <Reveal>
              <SectionLead>
                Rooted in the old palace quarter of Beşiktaş, {brand.name} {brand.location} is a house of 129 rooms and suites, four restaurants, a private hammam and a garden that opens onto the water.
              </SectionLead>
              <SectionLead className="mt-5">
                Our craft is quiet: unhurried mornings, considered detail, and the still confidence of a city that has always known how to receive its guests.
              </SectionLead>
              <div className="mt-10 grid grid-cols-3 gap-3 sm:gap-6 md:gap-12 border-t border-neutral-200 pt-8">
                <div>
                  <div className="font-serif text-[28px] sm:text-4xl md:text-5xl text-neutral-900 leading-none">129</div>
                  <div className="mt-3 tracking-[0.18em] text-[9.5px] sm:text-[10.5px] uppercase text-neutral-500 leading-snug">Rooms &<br className="sm:hidden" /> Suites</div>
                </div>
                <div>
                  <div className="font-serif text-[28px] sm:text-4xl md:text-5xl text-neutral-900 leading-none">04</div>
                  <div className="mt-3 tracking-[0.18em] text-[9.5px] sm:text-[10.5px] uppercase text-neutral-500 leading-snug">Restaurants</div>
                </div>
                <div>
                  <div className="font-serif text-[28px] sm:text-4xl md:text-5xl text-neutral-900 leading-none whitespace-nowrap">
                    3<span>&nbsp;</span>500<span className="text-[15px] sm:text-xl md:text-2xl align-top ml-0.5">m²</span>
                  </div>
                  <div className="mt-3 tracking-[0.18em] text-[9.5px] sm:text-[10.5px] uppercase text-neutral-500 leading-snug">Spa &<br className="sm:hidden" /> Wellness</div>
                </div>
              </div>
              <div className="mt-10">
                <GhostLink onClick={onBook}>Plan Your Visit</GhostLink>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      {/* Full-width image */}
      <Reveal className="w-full">
        <div className="relative w-full h-[62vh] md:h-[86vh] overflow-hidden">
          <img
            {...responsiveImageProps(pool.image, IMAGE_SIZES.full)}
            alt={pool.title}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover scale-[1.02] hover:scale-105 transition-transform [transition-duration:2000ms] ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          <div className="absolute bottom-8 md:bottom-14 left-0 right-0">
            <div className="max-w-[1440px] mx-auto px-5 md:px-10 text-white">
              <div className="tracking-[0.32em] text-[10.5px] uppercase text-white/80">Wellness</div>
              <div className="font-serif text-3xl md:text-5xl mt-3 max-w-2xl">{pool.title}</div>
              <p className="mt-3 max-w-xl text-white/85 font-light">{pool.desc}</p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default Introduction;
